

















import {
  Component,
  Vue,
  Watch,
  Prop,
  Emit,
  Model,
} from "vue-property-decorator";
import { Toast } from "vant";

@Component
export default class Toasts extends Vue {
  @Prop({ default: {}, type: Object, required: false })
  private toastObj!: object;
  @Prop({ type: Boolean, required: false }) private selected!: boolean;
  // @Prop({ type: Boolean, required: false, default: false })
  @Model("change") private foo!: boolean;

  private flagShow!: boolean;
  private msg: boolean = false;
  private showIcon: boolean = false;
  private showNoIcon: boolean = false;
  // @Model('change') private foo = false;

  private mounted() {
    setTimeout(() => {
      this.$emit("change", false);
    }, 2000);
  }

  @Emit("change")
  private hehe() {
    return true;
  }

  private created() {
    // Toast.setDefaultOptions({ duration: 500000000 });
    if ((this.toastObj as any).icon) {
         this.showIcon = true;
         this.showNoIcon = false;
      // Toast({
      //   message: (this.toastObj as any).message,
      //   icon: (this.toastObj as any).icon,
      // });
    } else {
      this.showNoIcon = true;
      this.showIcon = false;
      // Toast({ message: (this.toastObj as any).message });
    }
  }
  @Watch("foo")
  private changeValue(newVal: any, oldVal: any) {
    setTimeout(() => {
      this.$emit("change", false);
    }, 500);
  }
  // 带图标展示的轻提示
  // private showIconToast(res: any, icons: any) {
  //   Toast({ message: res, icon: icons });
  // }
  // // 不带图标展示的轻提示
  // private toast(res: any) {
  //   Toast({ message: res });
  // }
}
